module.exports = __webpack_public_path__ + "static/myconid_sprout-c685da75800110d263e6046453d8491e.jpg";